"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BREAKPOINTS = exports.PADDING = exports.MAX_WIDTH = exports.COLOR = void 0;
exports.COLOR = {
    font: {
        white: '#fff',
        base: '#4d4d51',
        placeholder: '#959597',
        disabledIcon: '#959597',
        error: '#E84B35',
    },
    border: {
        base: '#d3d3d4',
        focus: '#3172a0',
        error: '#E84B35',
    },
    background: {
        white: '#fff',
        disabled: '#f4f4f4',
        optional: '#959597',
        attention: '#E84B35',
        error: '#FFEDEB',
        buttonDisabled: '#D3D3D4',
    },
    formPartsIcon: {
        base: '#959597',
        active: '#0F80E9',
        disabled: '#D3D3D4',
    },
    progressBar: {
        background: '#F0F0F0',
        progress: '#0F80E9',
    },
};
exports.MAX_WIDTH = {
    content: '688px',
};
exports.PADDING = {
    content: {
        lessThanSmall: {
            rightAndLeft: '12px',
        },
        smallAndUp: {
            rightAndLeft: '24px',
        },
    },
};
var BREAKPOINTS_PIXEL_VALUE = {
    small: 576,
    medium: 768,
};
exports.BREAKPOINTS = {
    lessThanSmall: "max-width: " + (BREAKPOINTS_PIXEL_VALUE.small - 1) + "px",
    smallAndUp: "min-width: " + BREAKPOINTS_PIXEL_VALUE.small + "px",
    lessThanMedium: "max-width: " + (BREAKPOINTS_PIXEL_VALUE.medium - 1) + "px",
    mediumAndUp: "min-width: " + BREAKPOINTS_PIXEL_VALUE.medium + "px",
};
